import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  gap: 5px;
`;

export const Inner = styled.div`
  margin-left: 5px;
  position: relative;
`;
